import { render } from "./WalletFrom.vue?vue&type=template&id=1b7469be"
import script from "./WalletFrom.vue?vue&type=script&lang=js"
export * from "./WalletFrom.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__